'use client';

import Button from '../Button';
import styles from './styles.module.scss';
import listOfFeatures, { FeatureItem } from './listOfFeatures';
import Popover from '../Popover';
import { FunctionComponent } from 'react';

type FeatureProps = {
    feature: FeatureItem;
};

const Feature: FunctionComponent<FeatureProps> = ({ feature }) => (
    <Popover
        content={
            <div>
                <p className={styles.description}>{feature.description}</p>
            </div>
        }
    >
        <Button preset="default" className={styles.feature_button}>
            <span className={styles.btn_contents}>
                <span className={styles.icon}>{feature.icon}</span>
                {feature.label}
                {feature.badge ? <div className={styles.badge}>{feature.badge}</div> : null}
            </span>
        </Button>
    </Popover>
);

const FeaturesCard: FunctionComponent<{ heading: string; grouping: string }> = ({
    heading,
    grouping,
}) => {
    return (
        <div className={styles.features_card}>
            <h3 className={styles.heading}>{heading}</h3>
            <div className={styles.features_list}>
                {listOfFeatures
                    .filter((feature) => feature.grouping === grouping)
                    .map((feature) => (
                        <Feature key={feature.label} feature={feature} />
                    ))}
            </div>
        </div>
    );
};

export const GroupedFeatures: FunctionComponent = () => {
    return (
        <div className={styles.features}>
            <FeaturesCard heading="Booking System" grouping="booking_system" />
            <FeaturesCard heading="Learning Management System" grouping="online_course_lms" />
            <FeaturesCard heading="Training CRM" grouping="training_crm" />
        </div>
    );
};
